module.exports = __webpack_public_path__ + "static/img/img6-3.7fe81da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/buyone365/img6-3.png
// module id = YMz2
// module chunks = 0